import { DbLotteryFilter } from "./db-lottery-filter";
import { DbLotteryCardModels } from "./db-lottery-card-models";
import { Lottery } from "../../_shared/lottoloca-commom/lottery-modex";
import { DbLotteryFilters } from "./db-lottery-filters";
import { IDocumentReference, ICollectionReference } from '../database-cast/IDatabase';


export class DbLottery {


    private _docReference: IDocumentReference;

    constructor(lotteryId: string, collection: ICollectionReference) {
        this._docReference = collection.doc(`${lotteryId}`);
    }

    getFilter(id: string): DbLotteryFilter {

        let lotteryFilter = new DbLotteryFilter(id,this._docReference.collection("filters"));

        return lotteryFilter;
    }

    public getCardModels(): DbLotteryCardModels {
        return new DbLotteryCardModels(this._docReference.collection("card-models"));
    }

    public getFilters(): DbLotteryFilters {
        return new DbLotteryFilters(this._docReference.collection("filters"));
    }


    public getData(): Promise<Lottery> {

        return new Promise<Lottery>((resolve) => {
            this._docReference.get()
                .then(snapshot => {

                    let lottery: Lottery=  Object.assign( snapshot.data());

                    resolve(lottery);
                })
        });
    }


    public update(lottery: Lottery): Promise<Lottery> {

        let promise = new Promise<Lottery>((resolve, reject) => {

            this._docReference
                .set(Object.assign({}, lottery))
                .then(() => {
                    resolve(lottery);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return promise;
    }



}